import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/list-master/jain-panchang";

export const Route = createFileRoute("/admin/_list-master/jain-panchang")({
  component: Page,
});
